import UserNewPage from "./pages/user-new-page";
import UserEditPage from "./pages/user-edit-page";
import UserImportLogPage from "./pages/user-import-log-page";
import UserImportLogDetailsPage from "./pages/user-import-log-details-page";

const UserConfig = {
  routes: [
    {
      path: "/admin/users/new",
      component: UserNewPage,
      exact: true,
      title: "Add User",
      backUrl: "/admin",
      search: "?tab=users",
      state: { forceLoad: true },
      strict: true,
    },
    {
      path: "/admin/users/importLog",
      component: UserImportLogPage,
      exact: true,
      title: "Import Log",
      backUrl: "/admin",
      strict: true,
    },
    {
      path: "/admin/users/importLog/:logId",
      component: UserImportLogDetailsPage,
      exact: true,
      title: "Import Log Details",
      backUrl: "/admin/users/importLog",
      strict: true,
    },
    {
      path: "/admin/users/:id",
      component: UserEditPage,
      exact: true,
      title: "Edit User",
      backUrl: "/admin",
      search: "?tab=users",
      strict: true,
    },
  ],
};

export default UserConfig;
